/**
 * 生图任务来源只由服务端持久化的 request_id 推导。
 * 不接受调用方提交的来源，避免 Activity 或模型伪造聊天/指令来源。
 */
export const DISCORD_IMAGE_BUTTON_REQUEST_ID_PREFIX = "discord-image-button:";
const DISCORD_IMAGE_COMMAND_REQUEST_ID_PREFIX = `${DISCORD_IMAGE_BUTTON_REQUEST_ID_PREFIX}tool:`;
const DISCORD_IMAGE_COMMAND_HASH_REQUEST_ID_PREFIX = `${DISCORD_IMAGE_BUTTON_REQUEST_ID_PREFIX}tool-hash:`;

export type DiscordImageJobSource = "dialogue" | "command" | "manual";

/**
 * 保持既有幂等键协议：按钮直接点击是 dialogue；工具调用（包括长 call id 的哈希键）是 command；其余为 manual。
 */
export function discordImageJobSourceFromRequestId(requestId: string): DiscordImageJobSource {
  if (
    requestId.startsWith(DISCORD_IMAGE_COMMAND_REQUEST_ID_PREFIX)
    || requestId.startsWith(DISCORD_IMAGE_COMMAND_HASH_REQUEST_ID_PREFIX)
  ) return "command";
  if (requestId.startsWith(DISCORD_IMAGE_BUTTON_REQUEST_ID_PREFIX)) return "dialogue";
  return "manual";
}

/** Activity 的公开创建端点不得占用机器人保留的 request_id 命名空间。 */
export function isDiscordImageReservedRequestId(requestId: string): boolean {
  return requestId.startsWith(DISCORD_IMAGE_BUTTON_REQUEST_ID_PREFIX);
}
